/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* tslint:disable quotemark */
export default [
  "+js(acs, addEventListener,",
  "+js(acs, document.querySel",
  "+js(nosiif, visibility, 10",
  "app_vars.force_disable_adb",
  "+js(set, blurred, false)",
  "ectorAll, popMagic)",
  "+js(acs, document.",
  "+js(no-fetch-if, ",
  "[href^=\"https://",
  "[href^=\"http://",
  "+js(aopw, _pop)",
  "+js(no-xhr-if, ",
  "createElement, ",
  "BlockDetected)",
  "+js(nano-sib",
  "+js(nostif, ",
  "notification",
  " !important",
  ", noopFunc)",
  "+js(nowoif)",
  ":has-text(",
  "+js(aeld, ",
  "+js(aopr, ",
  "+js(aopw, ",
  "=\"https://",
  "background",
  ".*,xhamst",
  ".buzz,img",
  "+js(acs, ",
  "+js(set, ",
  "container",
  "decodeURI",
  "div[id^=\"",
  "div[style",
  "placehold",
  ",amazon.",
  ",google.",
  "disclaim",
  "300x250",
  "consent",
  "content",
  "message",
  "privacy",
  "sponsor",
  "wrapper",
  ".co.uk",
  ".com##",
  "[class",
  "accept",
  "banner",
  "bottom",
  "cookie",
  "Cookie",
  "crypto",
  "google",
  "notice",
  "policy",
  "widget",
  ".com,",
  "block",
  "cript",
  "movie",
  "popup",
  "video",
  ".com",
  ".net",
  ".nl,",
  ".xyz",
  "#@#.",
  "+js(",
  "gdpr",
  "html",
  "ight",
  "mobi",
  "news",
  "porn",
  "side",
  "text",
  "tube",
  "www.",
  " > ",
  ".*,",
  ".de",
  "age",
  "box",
  "div",
  "ent",
  "ive",
  "lay",
  "mod",
  "top",
  "web",
  "xxx",
  "__",
  "--",
  ", ",
  ": ",
  ".*",
  ".f",
  ".j",
  ".p",
  ".t",
  "\"]",
  "##",
  "=\"",
  "00",
  "a-",
  "ab",
  "ad",
  "Ad",
  "al",
  "am",
  "an",
  "ap",
  "ar",
  "as",
  "at",
  "au",
  "av",
  "bo",
  "ch",
  "ck",
  "cl",
  "co",
  "ct",
  "d-",
  "de",
  "di",
  "do",
  "e-",
  "ed",
  "el",
  "em",
  "en",
  "er",
  "es",
  "et",
  "ex",
  "fo",
  "g-",
  "ga",
  "go",
  "he",
  "ho",
  "ic",
  "id",
  "ie",
  "if",
  "ig",
  "il",
  "im",
  "in",
  "ip",
  "ir",
  "is",
  "it",
  "la",
  "le",
  "lo",
  "ma",
  "me",
  "mp",
  "no",
  "ok",
  "ol",
  "om",
  "on",
  "op",
  "or",
  "ot",
  "ov",
  "po",
  "ra",
  "re",
  "ro",
  "s_",
  "s-",
  "se",
  "sh",
  "sp",
  "st",
  "t-",
  "ta",
  "th",
  "ti",
  "tr",
  "ub",
  "ul",
  "um",
  "un",
  "up",
  "ur",
  "us",
  "ut",
  "y-",
  " ",
  "_",
  "-",
  ",",
  ";",
  ":",
  ".",
  "(",
  ")",
  "[",
  "/",
  "#",
  "^",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "A",
  "b",
  "B",
  "c",
  "C",
  "d",
  "D",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "L",
  "m",
  "M",
  "n",
  "o",
  "p",
  "P",
  "q",
  "r",
  "R",
  "s",
  "S",
  "t",
  "T",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];